<template>
  <div>
    <h2 class="display-1 mt-5"> {{ $t('analytics.heading') }} </h2>
    <v-row>
      <v-col cols="12" xs="1" md="6">
        <PolygonLoader
          v-if="loadingCaseStatisticsOverTime"
          :centered="false"
          :size="40"
          :width="3"
        />
        <p v-else-if="errorLoadingCaseStatisticsOverTime"> {{$t('pages.loadErrorMessage')}} </p>
        <PolygonAnalyticChart
          v-if="chartCaseStatisticsOverTime"
          id="chart_id_caseStatisticsOverTime"
          :title="chartCaseStatisticsOverTime.title"
          :description="chartCaseStatisticsOverTime.description"
          :chartData="chartCaseStatisticsOverTime.data"
        />
      </v-col>
      <v-col cols="12" xs="1" md="6">
        <PolygonLoader
          v-if="loadingActiveCasesByWorkType"
          :centered="false"
          :size="40"
          :width="3"
        />
        <p v-else-if="errorLoadingActiveCasesByWorkType"> {{$t('pages.loadErrorMessage')}} </p>
        <PolygonAnalyticChart
          v-if="chartActiveCasesByWorkType"
          id="chart_id_activeCasesByWorkType"
          :title="chartActiveCasesByWorkType.title"
          :description="chartActiveCasesByWorkType.description"
          :chartData="chartActiveCasesByWorkType.data"
        />
      </v-col>
    </v-row>

  </div>
</template>

<script>
import repository from '@/core/repository/analytics-repository'
import chroma from 'chroma-js'
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      loadingCaseStatisticsOverTime: null,
      loadingActiveCasesByWorkType: null,
      chartCaseStatisticsOverTime: null,
      chartActiveCasesByWorkType: null,
      errorLoadingCaseStatisticsOverTime: null,
      errorLoadingActiveCasesByWorkType: null
    }
  },
  computed: {
    ...mapGetters([
      'currentTheme'
    ]),
    colorOptions() {
      return [
        chroma(this.currentTheme.colors.cssVariables['--color-warning']).alpha(0.5).css(),
        chroma(this.currentTheme.colors.cssVariables['--color-success']).alpha(0.5).css()
      ]
    }
  },
  activated() {
    this.getCaseStatistcs()
    this.getActiveCasesByWorkType()
  },
  methods: {
    async getCaseStatistcs() {
      this.loadingCaseStatisticsOverTime = true
      this.errorLoadingCaseStatisticsOverTime = false
      try {
        const caseStatisticsOverTime = await repository.getCaseStatisticsOverTime()
        _.each(caseStatisticsOverTime.data.datasets, (item, index) => {
          item.backgroundColor = this.colorOptions[index]
          item.label = (index === 0) ? this.$t('analytics.opened') : this.$t('analytics.finished')
        })
        const chartInfo = this.addTitleAndDescription(caseStatisticsOverTime, 1)
        this.chartCaseStatisticsOverTime = chartInfo
      } catch (error) {
        console.log(error)
        this.errorLoadingCaseStatisticsOverTime = true
      } finally{
        this.loadingCaseStatisticsOverTime = false
      }
    },
    async getActiveCasesByWorkType() {
      this.loadingActiveCasesByWorkType = true
      this.errorLoadingActiveCasesByWorkType = false
      try {
        const activeCasesByWorkType = await repository.getActiveCasesByWorkType()
        const chartInfo = this.addTitleAndDescription(activeCasesByWorkType, 2)
        this.chartActiveCasesByWorkType = chartInfo
      } catch (error) {
        console.log(error)
        this.errorLoadingActiveCasesByWorkType = true
      } finally{
        this.loadingActiveCasesByWorkType = false
      }
    },
    addTitleAndDescription(chartData, id) {
      let chartInfo = {}
      chartInfo.data = chartData
      chartInfo.title = _.chain(this.$t('analytics.diagrams')).find({ id: id }).get('title').value()
      chartInfo.description = _.chain(this.$t('analytics.diagrams')).find({ id: id }).get('description').value()
      return chartInfo
    }
  }
}
</script>
